import { render, staticRenderFns } from "./TablaSolicitudInformacion.vue?vue&type=template&id=104eb45a&scoped=true&lang=pug&"
import script from "./TablaSolicitudInformacion.vue?vue&type=script&lang=js&"
export * from "./TablaSolicitudInformacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104eb45a",
  null
  
)

export default component.exports